import { render, staticRenderFns } from "./filedown.vue?vue&type=template&id=2c27c3d5"
import script from "./filedown.vue?vue&type=script&lang=js"
export * from "./filedown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports